import script from "./NavigationRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationRoute.vue?vue&type=script&setup=true&lang=js"

import "./NavigationRoute.vue?vue&type=style&index=0&id=2414fe4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2414fe4d"]])

export default __exports__